import { Component, ViewChild } from '@angular/core';
import { _, TranslatePipe } from "@ngx-translate/core";
import { EntityNextStepService, NextLevelQueryResponseLineDTO } from '@app/core/services/http-services/model/entity-next-step.service';
import { map, Observable, tap } from 'rxjs';
import { TreeListComponent, ExpandableDirective, ColumnComponent, CellTemplateDirective, ColumnGroupComponent } from '@progress/kendo-angular-treelist';
import { AoTBalanceService } from '@app/core/services/http-services/aot/aot-balance.service';
import { Guid } from 'guid-typescript';
import { MultiColumnComboBoxComponent, ComboBoxColumnComponent } from '@progress/kendo-angular-dropdowns';
import { AsyncPipe, DecimalPipe, DatePipe } from '@angular/common';

_('Operative.CreateChainPOInProgress');

@Component({
    selector: 'app-create-multi-step-prod-order-v2',
    templateUrl: './create-multi-step-prod-order.component-v2.html',
    styleUrls: ['./create-multi-step-prod-order.component-v2.css'],
    imports: [TreeListComponent, ExpandableDirective, ColumnComponent, CellTemplateDirective, MultiColumnComboBoxComponent, ComboBoxColumnComponent, ColumnGroupComponent, AsyncPipe, DecimalPipe, DatePipe, TranslatePipe]
})
export class CreateMultiStepProdOrderComponentV2 {

  @ViewChild("treelist") public treelist: TreeListComponent;

  public rootActivityIndex: number;
  public selectedDate: Date;
  public siteId: Guid;

  public rootData: Observable<NextLevelQueryResponseLineDTO[]>

  public initiallyExpanded:number[] = [];

  public loading = true;

  constructor(
    private readonly entityNextStepService: EntityNextStepService,
    private readonly aoTBalanceService: AoTBalanceService
  ) {
  }

  start(){
    this.rootData = this.entityNextStepService.getNextStep({
      activityIndex: this.rootActivityIndex,
      direction: 0,
      level: 0,
      qty: 100,
      qtyUnit: 'M3'
    }).pipe(
      map(items => this.mapFocast(items, this.rootActivityIndex)),
      tap(items => {
       for(let item of items){
        this.initiallyExpanded.push(item.id);
       }
       this.loading = false;
      }
      ));
  }

  public fetchChildren = (item: NextLevelQueryResponseLineDTO): Observable<NextLevelQueryResponseLineDTO[]> => {
    return this.entityNextStepService.getNextStep({
      activityIndex: item.selectedActivityIndex,
      direction: 0,
      level: item.level + 1,
      qty: item.qty,
      qtyUnit: 'M3'
    }).pipe(
      map(items => this.mapFocast(items, item.selectedActivityIndex))
    );
  };

  public mapFocast = (items: NextLevelQueryResponseLineDTO[], activityIndex: number) => {
    this.aoTBalanceService.getActivityMaterialForecastVolume(activityIndex, this.selectedDate, this.siteId)
    .subscribe(forcastLines => {
       for(let item of items){
        item.forcast =  forcastLines.find(p => p.entityIndex == item.materialIndex)?.forecastVolume;
       }
    })
    return items;
  }
  public hasChildren = (item: NextLevelQueryResponseLineDTO): boolean => {
    return true;
  };

  public onActivityChange($event, dataItem){
    dataItem.selectedActivityIndex = $event.target.value;
  }
}
